module.exports = __webpack_public_path__ + "static/media/OP_0023_corporate-01.5c019af3.png";